import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { environment } from '../../environments/environment';
import { CatalogComponent } from './catalog/catalog.component';

const CATALOG_MFE_DATA = {
  isMfe: true,
  module: environment.modules.catalog,
  hideBreadcrumbs: true
} as const;

export const routes: Routes = [
  {
    path: '',
    data: {
      isMfe: true,
      module: environment.modules.catalog,
      hideBreadcrumbs: true
    },
    children: [
      {
        path: environment.modules.products,
        component: CatalogComponent,
        data: {
          ...CATALOG_MFE_DATA,
          submodule: environment.modules.products,
          reuse: true
        },
        children: [
          {
            path: '**',
            component: CatalogComponent,
            data: {
              ...CATALOG_MFE_DATA,
              reuse: true
            }
          }
        ]
      },
      {
        path: environment.modules.makers,
        component: CatalogComponent,
        data: {
          ...CATALOG_MFE_DATA,
          submodule: environment.modules.makers,
          reuse: true
        },
        children: [
          {
            path: '**',
            component: CatalogComponent,
            data: {
              ...CATALOG_MFE_DATA,
              reuse: true
            }
          }
        ]
      },
      {
        path: '',
        redirectTo: environment.modules.products,
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CatalogMfeRoutingModule {}
